import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/preferences`;

export const getSavePreferenceRequest = (preference) => [getEndpoint(), getHttpPostOptions(preference)];

const getViewAllPreferencesEndpoint = (personExternalReference) => `${getEndpoint()}/${personExternalReference}`;
export const getViewAllPreferencesRequest = (personExternalReference) => [
  getViewAllPreferencesEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getSavePreferencesEndpoint = () => `${getEndpoint()}/create-multiple-preferences`;
export const getSavePreferencesRequest = (preferences) => [
  getSavePreferencesEndpoint(),
  getHttpPostOptions(preferences),
];
